import { CalendarSlotState } from "./CalendarSlotState";

export class CalendarSlotCell {
  time: string = '';
  state: CalendarSlotState = CalendarSlotState.Empty;
  timeSlotConfigurationId: number | null = null;

  constructor(init?: Partial<CalendarSlotCell>) {
    Object.assign(this, init); 
  }
}
